import * as THREE from "three";
import React, { useRef } from 'react';

export default function Ring(props) {
    const mesh = useRef();

    return (
        <mesh
            scale={[7, 7, 7]}
            position={props.position}
            rotation={[Math.PI / 2, 0, 0]}>
            <torusBufferGeometry args={[1, 0.005, 25, 100]} />
            <meshPhongMaterial side={THREE.DoubleSide} transparent={true} opacity={0.5} />
        </mesh>
    );
}